import * as React from 'react';

import { cn } from '@easydatasolution/ui-react/lib/utils';
import * as production from 'react/jsx-runtime';
import rehypeReact from 'rehype-react';
import remarkParse from 'remark-parse';
import remarkRehype from 'remark-rehype';
import { unified } from 'unified';

import { MarkdownLink } from './Markdown/MarkdownLink';

const processor = unified()
	.use(remarkParse)
	// @ts-ignore
	.use(remarkRehype, { allowDangerousHTML: true })
	// @ts-expect-error
	.use(rehypeReact, {
		...production,
		components: {
			// Use CustomLink instead of <a>
			a: MarkdownLink,
		},
	});

type ElementType = keyof JSX.IntrinsicElements;

interface MarkdownRawProps<T extends ElementType = 'div'> {
	children: string;
	as?: T;
	className?: string;
}

export const MarkdownRaw = <T extends ElementType = 'div'>({
	children,
	as,
	className,
	...rest
}: MarkdownRawProps<T> & Omit<React.ComponentPropsWithoutRef<T>, keyof MarkdownRawProps<T>>) => {
	const Component = as ?? ('div' as React.ElementType);
	return (
		<Component className={cn('prose prose-slate', className)} {...rest}>
			{processor.processSync(children).result}
		</Component>
	);
};
